import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Components/Images/logo.png";
import { addDoc, collection } from "firebase/firestore";
import db from "../firestore";
import Header from "../Components/Header";
import { ToastContainer, toast } from "react-toastify";

function TestimonialAdd() {
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");

  const testimonialRef = collection(db, "Testimonials");
  let navigate = useNavigate();

  const createTestimonial = async () => {
    await addDoc(testimonialRef, { Name: name, Title: title, Text: text })
    .then(
      toast.success("Updated 👍", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    )
    navigate("/dashboard");
  };

  return (
    <div className="flex flex-col items-center">
      <Header />
      <div>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>

      <div className="w-3/4 border rounded mt-10 p-5 flex flex-col gap-5">
        <h2 className="text-2xl font-bold">Adding Testimonial</h2>
        <input
          type="text"
          placeholder="Testimonial Name*"
          onChange={(e) => {
            setName(e.target.value);
          }}
          className="border rounded p-2"
        />
        <input
          type="title"
          placeholder="Testimonial Title*"
          onChange={(e) => {
            setTitle(e.target.value);
          }}
          className="border rounded p-2"
        />
        <textarea
          placeholder="Testimonial Text*"
          onChange={(e) => {
            setText(e.target.value);
          }}
          className="border rounded p-2"
        />

        <button
          className="rounded bg-add-green px-5 py-2 text-white hover:bg-add-green2 w-1/4"
          onClick={createTestimonial}
        >
          Add
        </button>
      </div>
    </div>
  );
}

export default TestimonialAdd;
